<template>
    <!-- Admin → Centro de QA (/admin/centro-qa, /admin/centro-qa/historial,
         /admin/centro-qa/<clave>, /admin/centro-qa/<clave>/actual). Cada integración se corre en prueba, se
         revisa, se integra y recién ahí se habilita para que corra sola a una
         hora. Diseño = demo aprobada (OneDrive\Desktop\herramienta-QA); la
         pantalla la dibuja qaApp.js y los estilos salen de la demo (qaCentro.css).
         Datos: QaController (admin/qa…, módulo `centro-qa`). -->
    <div class="qa-raiz-wrap">
        <div ref="raiz" class="qa-raiz"></div>
        <!-- Cargas y corridas: el loader de House & Flats, como en el resto del
             sitio. qaApp avisa qué mostrar (estadoCarga): una carga (solo el
             logo), o una corrida con su paso, avance y, al terminar, si salió
             bien o con error y los botones para seguir. -->
        <HyFLoader
            v-if="carga"
            :key="carga.modo"
            variant="overlay"
            :paused="carga.modo === 'corrida' && carga.estado !== 'curso'"
            :aria-label="carga.modo === 'carga' ? carga.texto : carga.titulo"
        >
            <!-- Cargas de pantalla: solo el logo (el texto queda para lectores de pantalla). -->
            <div v-if="carga.modo === 'corrida'" class="qa-ld" :class="'qa-ld--' + carga.estado">
                <p class="qa-ld-t">
                    <span v-if="carga.estado !== 'curso'" class="qa-ld-ico" aria-hidden="true">{{ carga.estado === 'error' ? '!' : '✓' }}</span>{{ carga.titulo }}
                </p>
                <p v-if="carga.sub" class="qa-ld-sub">{{ carga.sub }}</p>
                <template v-if="carga.estado === 'curso'">
                    <div class="qa-ld-bar" role="progressbar" aria-label="Avance" aria-valuemin="0" aria-valuemax="100" :aria-valuenow="carga.pct"><span :style="{ width: carga.pct + '%' }"></span></div>
                    <p class="qa-ld-paso"><span>{{ carga.paso }}</span><span>{{ carga.pct }} %</span></p>
                </template>
                <p v-else-if="carga.estado === 'ok'" class="qa-ld-paso">{{ carga.paso }}</p>
                <ul v-if="carga.resumen" class="qa-ld-res">
                    <li v-for="r in carga.resumen" :key="r.t"><span>{{ r.t }}</span><b>{{ r.n }}</b></li>
                </ul>
                <p v-if="carga.detalle" class="qa-ld-err">{{ carga.detalle }}</p>
                <div class="qa-ld-acts">
                    <button
                        v-for="a in carga.acciones"
                        :key="a.t"
                        type="button"
                        class="bk-btn"
                        :class="a.primario ? 'bk-btn--primary' : 'bk-btn--ghost'"
                        @click="accion(a)"
                    >{{ a.t }}</button>
                </div>
            </div>
        </HyFLoader>
    </div>
</template>

<script>
import axios from 'axios';
import { montar } from './qaApp';
import HyFLoader from '@/components/Loader/HyFLoader.vue';

const BASE = () => `${process.env.VUE_APP_API_URL}admin/qa`;
/** Errores de axios → { status, data } (lo que espera el motor). */
const fallo = e => { const r = e && e.response; throw { status: r ? r.status : 0, data: r ? r.data : null }; };
const api = {
    get: r => axios.get(BASE() + r).then(x => x.data, fallo),
    post: (r, b) => axios.post(BASE() + r, b || {}).then(x => x.data, fallo),
    patch: (r, b) => axios.patch(BASE() + r, b || {}).then(x => x.data, fallo),
};

export default {
    name: 'CentroQa',
    components: { HyFLoader },
    data() {
        return { carga: null };
    },
    mounted() {
        this.app = montar(this.$refs.raiz, {
            api,
            navegar: vista => {
                const destino = vista === 'admin' ? '/admin' : vista ? `/admin/centro-qa/${vista}` : '/admin/centro-qa';
                if (this.$route.fullPath !== destino) this.$router.push(destino).catch(() => {});
            },
            carga: estado => { this.carga = estado; },
        });
        this.ir();
    },
    watch: {
        $route() { this.ir(); },
    },
    beforeRouteLeave(to, from, next) {
        if (this.app && this.app.ocupado() && !window.confirm('Hay cambios que todavía se están guardando. ¿Salir igual?')) { next(false); return; }
        next();
    },
    beforeDestroy() {
        if (this.app) this.app.destruir();
    },
    methods: {
        accion(a) {
            if (this.app) this.app.accion(a);
        },
        ir() {
            if (this.$route.name !== 'admin-centro-qa') return;
            const { vista, sub } = this.$route.params;
            this.app.ir(vista ? (sub ? `${vista}/${sub}` : vista) : '');
        },
    },
};
</script>

<style src="../../BankInformation/bkCuenta.css"></style>
<style src="../../Cuenta/cuentaMenu.css"></style>
<style src="./qaCentro.css"></style>
